import type { ReactNode } from 'react';
import ClusterViewModeSwitcher from '@/app/KeywordResearch/components/keyword-clustring/components/ClusterViewModeSwitcher';
import { TabHelpButton } from './SectionHelpDrawer';
import type { TabGuideKey } from '../lib/page-guides';

export type WorkspaceMode = 'manual' | 'schedule' | 'charts';

export function WorkspaceModeSwitch({
  value,
  onChange,
  context,
  aside,
}: {
  value: WorkspaceMode;
  onChange: (next: WorkspaceMode) => void;
  context: 'index' | 'inspect';
  /** Controls on the physical left (e.g. range select). */
  aside?: ReactNode;
}) {
  return (
    <div
      className={
        aside
          ? 'workspace-mode-wrap workspace-mode-wrap--with-aside'
          : 'workspace-mode-wrap'
      }
    >
      {aside ? <div className="workspace-mode-aside">{aside}</div> : null}
      <ClusterViewModeSwitcher
        value={value}
        onChange={(id) => onChange(id as WorkspaceMode)}
        aria-label="حالت ارسال"
        modes={[
          {
            id: 'charts',
            icon: 'bar-chart',
            label: (
              <>
                تاریخچه
                <TabHelpButton
                  guideKey={`${context}-charts` as TabGuideKey}
                />
              </>
            ),
          },
          {
            id: 'manual',
            icon: 'list-ul',
            label: (
              <>
                ارسال دستی
                <TabHelpButton
                  guideKey={`${context}-manual` as TabGuideKey}
                />
              </>
            ),
          },
          {
            id: 'schedule',
            icon: 'arrow-repeat',
            label: (
              <>
                زمان‌بندی
                <TabHelpButton
                  guideKey={`${context}-schedule` as TabGuideKey}
                />
              </>
            ),
          },
        ]}
      />
    </div>
  );
}
